import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { LOGIN_PATH } from '../constants';
import { selectRefreshToken } from '../store/user/selectors';

type AuthProtectedCallback = (...args: Array<unknown>) => unknown;

/**
 * **`callback` must be memoised in order to avoid unnecessary re-renders**
 * */
const useAuthProtectedAction = (callback: AuthProtectedCallback) => {
  const token = useSelector(selectRefreshToken);

  return useCallback(
    (...args: Array<unknown>) => {
      if (!token) {
        window.location.href = `${LOGIN_PATH}?redirect=${window.location.pathname}`;
        return;
      }
      callback(...args);
    },
    [token, callback]
  );
};

export default useAuthProtectedAction;
